/* created by CoolGuy on 2018/12/4 */
import React from 'react';
import { direct, style } from './image';
import moment from 'moment';
import {fixedLength} from './util';
window.__moment = moment;
export const getSourceDom = url => {
  let params = {};
  if (url && (url + '').indexOf('.m3u8') > -1) {
    params.type = 'application/x-mpegURL';
  }
  let decodeUrl = '';
  try {
    decodeUrl = decodeURIComponent(url);
  } catch (e) {
    decodeUrl = '';
  }

  if (
    decodeUrl &&
    decodeUrl.indexOf('http') != 0 &&
    decodeUrl.indexOf('//') != 0
  ) {
    decodeUrl = direct(decodeUrl);
  }
  return <source src={decodeUrl} {...params} />;
};

export const getSource = function(url, data, option) {
  return getSourceDom(url);
};

export const formatDuration = function(duration, unit) {
  let instance = unit ? moment.duration(Number(duration), unit) : moment.duration(Number(duration));
  let minutes = Math.floor(instance.asMinutes());
  let seconds = instance.get('seconds');
  minutes = fixedLength(minutes);
  seconds = fixedLength(seconds);

  return `${minutes}:${seconds}`;
};

export const languages = {
  zh: {
    Play: '播放',
    LIVE: '直播'
  }
};
